<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-6">
      <label for=""></label>
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-3">
      <div [formGroup]="formularioFiltroEstadoDeVendedores" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbFiltroEstados" [label]="'Estado *'" formControlName="idEstadoVendedor"
          [control]="formularioFiltroEstadoDeVendedores.get('idEstadoVendedor')" [id]="'idEstadoVendedor'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <div class="form-group col-md-3">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>

  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Descripcion'"
          [label]="'Descripcion *'" [id]="'descripcion'" formControlName="descripcion"
          [control]="formulario.get('descripcion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Sueldo Variable'"
          [label]="'Sueldo Variable *'" [id]="'sueldoVariable'" formControlName="sueldoVariable"
          [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descCorta'" [idOpcion]="'idUnidad'"
          [comboBox]="listUnidadesNegocioSAP" formControlName="unidadNegocio"
          [control]="formulario.get('unidadNegocio')" [label]="'Unidad Negocio *'" [id]="'unidadNegocio'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbEstados" formControlName="estado" [control]="formulario.get('estado')" [label]="'Estado *'"
          [id]="'estado'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>

</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Tipo de Vendedor'" [idButton]="'buttonAbrirModal'"
  [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="row">
        <div class="form-group col-12 col-md-12">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'ID'"
            [label]="'ID *'" [id]="'idTipo'" formControlName="idTipo"
            [control]="formulario.get('idTipo')"></app-lfsa-input>
        </div>
        <div class="form-group col-12">
          <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Descripcion'"
            [label]="'Descripcion *'" [id]="'descripcion'" formControlName="descripcion"
            [control]="formulario.get('descripcion')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Sueldo Variable'"
            [label]="'Sueldo Variable *'" [id]="'sueldoVariable'" formControlName="sueldoVariable"
            [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descCorta'" [idOpcion]="'idUnidad'"
            [comboBox]="listUnidadesNegocioSAP" formControlName="unidadNegocio"
            [control]="formulario.get('unidadNegocio')" [label]="'Unidad Negocio *'" [id]="'unidadNegocio'">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
            [comboBox]="cmbEstados" formControlName="estado" [control]="formulario.get('estado')" [label]="'Estado *'"
            [id]="'estado'">
          </app-lfsa-combo-box>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-4"></div>
    <div class="form-group col-12 col-md-4">
      <button class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="actualizar()">
        <i class="fa fa-save"></i>
        Guardar</button>
    </div>
    <div class="form-group col-12 col-md-4"></div>
  </div>
</ng-template>